import { makeStyles } from '@material-ui/core/styles';

interface RiskScoreProps {
  /** Maximum score  */
  maximum: number;

  /** Risk score */
  score: number;
}

const useStyles = makeStyles((theme) => ({
  item: {
    background: theme.palette.common.backgroundDark,
    borderRadius: 12,
    color: theme.palette.common.greyLighter,
    fontSize: 35,
    fontWeight: 'bold',
    height: 55,
    lineHeight: '55px',
    margin: 0,
    padding: 0,
    textAlign: 'center',
    width: 55,
    '&.selected': {
      color: theme.palette.common.tan,
      background: theme.palette.common.backgroundNotification,
      fontSize: 45,
      height: 65,
      lineHeight: '65px',
      width: 65,
    },
  },
  list: {
    alignItems: 'center',
    display: 'flex',
    gap: 5,
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: '35px 0',
  },
}));

function RiskScore({ maximum, score }: RiskScoreProps) {
  const classes = useStyles();

  const items = Array.from({
    length: maximum,
  });

  const classNames = (value: number) => {
    if (value === score) {
      return `${classes.item} selected`;
    }

    return classes.item;
  };

  return (
    <div className={classes.root}>
      <ol className={classes.list}>
        {items.map((_, index) => (
          <li className={classNames(index + 1)} key={index + 1}>
            {index + 1}
          </li>
        ))}
      </ol>
    </div>
  );
}

export default RiskScore;
